import { render, staticRenderFns } from "./OtherResources.vue?vue&type=template&id=dcdbab48&scoped=true"
import script from "./OtherResources.vue?vue&type=script&lang=js"
export * from "./OtherResources.vue?vue&type=script&lang=js"
import style0 from "./OtherResources.vue?vue&type=style&index=0&id=dcdbab48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdbab48",
  null
  
)

export default component.exports